/**
 * UI elements
 */
class PP_Graduates {
	constructor () {
        if (!$('.graduates-search-input').length) {
            return;
        }

        this.initState();
		this.initEvents();
	}

	initState () {
		this.UI = {
            input: $('.graduates-search-input'),
            items: $('.graduates-list-item'),
            emptyState: $('.graduates-list-no-results'),
            categories: $('.graduates-categories-list-item-link')
        };
	}

    initEvents () {
        this.UI.input.on('input', () => {
            let phrase = this.UI.input.val().toLowerCase();
            let founded = false;

            this.deactivateCategory();

            if (phrase.trim() === '') {
                this.UI.items.removeClass('is-hidden');
                this.UI.emptyState.addClass('is-hidden');
                return;    
            }

            this.UI.items.addClass('is-hidden');
            
            for (let i = 0; i < this.UI.items.length; i++) {
                if (this.UI.items.eq(i).attr('data-search').indexOf(phrase) > -1) {
                    this.UI.items.eq(i).removeClass('is-hidden');
                    founded = true;
                }
            }

            if (founded) {
                this.UI.emptyState.addClass('is-hidden');
            } else {
                this.UI.emptyState.removeClass('is-hidden');
            }
        });

        this.UI.categories.on('click', (e) => {
            e.preventDefault();
            this.UI.input.val('');
            this.UI.items.addClass('is-hidden');
            this.UI.categories.removeClass('is-active');
            let founded = false;
            let categoryName = $(e.target).attr('data-category');
            $(e.target).addClass('is-active');

            for (let i = 0; i < this.UI.items.length; i++) {
                if (this.UI.items.eq(i).attr('data-categories').indexOf('|' + categoryName + '|') > -1) {
                    this.UI.items.eq(i).removeClass('is-hidden');
                    founded = true;
                }
            }

            if (founded) {
                this.UI.emptyState.addClass('is-hidden');
            } else {
                this.UI.emptyState.removeClass('is-hidden');
            }
        });
    }

    deactivateCategory () {
        this.UI.categories.removeClass('is-active');
        this.UI.items.removeClass('is-hidden');
        this.UI.emptyState.addClass('is-hidden');
    }
}
